const data = {
  piuVersioniOptions: [
    { code: "1.1b", description: "Sì" },
    { code: "1.2b", description: "No" },
  ],
  compagniaOptions: [
    { code: "2.1", description: "Alleanza Assicurazioni" },
    { code: "2.2", description: "Allianz" },
    { code: "2.3", description: "Allianz Global Life" },
    { code: "2.4", description: "Allianz Leben AG" },
    { code: "2.5", description: "Athora Italia" },
    { code: "2.6", description: "Arca Vita" },
    { code: "2.7", description: "Arca Vita International" },
    { code: "2.8", description: "Assimoco Vita" },
    { code: "2.11", description: "Aviva Vita" },
    { code: "2.12", description: "AXA Assicurazioni" },
    { code: "2.13", description: "AXA-MPS Assicurazioni Vita" },
    { code: "2.14", description: "AXA-MPS Financial" },
    { code: "2.15", description: "Azimut Life" },
    { code: "2.16", description: "BAP Vita e Previdenza" },
    { code: "2.17", description: "BCC Vita" },
    { code: "2.18", description: "BIM Vita" },
    { code: "2.19", description: "Banco BPM Vita" },
    { code: "2.65", description: "BBPM Life" },
    { code: "2.20", description: "Cardif Lux Vie" },
    { code: "2.21", description: "Cardif Vita" },
    { code: "2.22", description: "Cattolica Assicurazioni" },
    { code: "2.23", description: "CF Life" },
    { code: "2.24", description: "Medvida Partners" },
    { code: "2.25", description: "UniCredit Life Insurance" },
    { code: "2.9", description: "CNP Vita Assicura" },
    { code: "2.10", description: "CNP Vita Assicurazione" },
    { code: "2.26", description: "Credemvita" },
    { code: "2.27", description: "Crédit Agricole Vita" },
    { code: "2.28", description: "Credit Suisse Life & Pensions" },
    { code: "2.66", description: "Cronos Vita" },
    { code: "2.30", description: "Darta Saving Life Assurance" },
    { code: "2.31", description: "Eurovita" },
    { code: "2.32", description: "Fideuram Vita" },
    { code: "2.33", description: "FWU Life" },
    { code: "2.63", description: "GamaLife" },
    { code: "2.34", description: "Generali Italia" },
    { code: "2.35", description: "Generali Luxembourg" },
    { code: "2.67", description: "Genertel" },
    { code: "2.36", description: "Genertellife" },
    { code: "2.37", description: "Grazer Wechselseitige" },
    { code: "2.38", description: "Groupama Assicurazioni" },
    { code: "2.39", description: "HDI Assicurazioni" },
    { code: "2.40", description: "Helvetia Vita" },
    { code: "2.41", description: "InChiaro Life" },
    { code: "2.68", description: "Intesa Sanpaolo Assicurazioni" },
    { code: "2.64", description: "Intesa Sanpaolo Assicurazioni - Dublin Branch" },
    { code: "2.42", description: "Intesa Sanpaolo Life" },
    { code: "2.43", description: "Intesa Sanpaolo Vita" },
    { code: "2.44", description: "Italiana Assicurazioni" },
    { code: "2.45", description: "ITAS Vita" },
    { code: "2.46", description: "La Mondiale Europartner" },
    { code: "2.47", description: "Lombard International Assurance" },
    { code: "2.48", description: "Lombarda Vita" },
    { code: "2.49", description: "Mediolanum International Life" },
    { code: "2.50", description: "Mediolanum Vita" },
    { code: "2.51", description: "Nobis Vita" },
    { code: "2.52", description: "Poste Vita" },
    { code: "2.53", description: "Pramerica Life" },
    { code: "2.54", description: "Reale Mutua" },
    { code: "2.55", description: "Sara Vita" },
    { code: "2.56", description: "SOGELIFE" },
    { code: "2.29", description: "UniCredit Vita Assicurazioni" },
    { code: "2.57", description: "Unipol Assicurazioni" },
    { code: "2.58", description: "Vera Financial" },
    { code: "2.59", description: "Vera Vita" },
    { code: "2.60", description: "Vittoria Assicurazioni" },
    { code: "2.61", description: "Wiener Städtische" },
    { code: "2.62", description: "Zurich Investments Life" },
  ],
  mercatoOptions: [
    { code: "3.1", description: "Retail" },
    { code: "3.2", description: "Private" },
    { code: "3.3", description: "Business" },
  ],
  canaleOptions: [
    { code: "4.1", description: "Banca" },
    { code: "4.2", description: "Consulenti Finanziari" },
    { code: "4.3", description: "Agenti" },
    { code: "4.4", description: "Broker" },
    { code: "4.5", description: "Diretto" },
  ],
  tipologiaProdottoOptions: [
    { code: "6.1", description: "Unit Linked Classica" },
    { code: "6.2", description: "Unit Linked Protetta" },
    { code: "6.3", description: "Unit Linked Ibrida" },
    { code: "6.4", description: "Multiramo" },
    { code: "6.5", description: "Ramo I - Tradizionale" },
    { code: "6.6", description: "Ramo I - Rendita" },
    { code: "6.7", description: "Ramo I - Capitale Differito" },
    { code: "6.8", description: "Ramo V" },
    { code: "6.9", description: "PIR" },
    { code: "6.10", description: "Variable Annuity" },
    { code: "6.11", description: "PIP" },
  ],
  tipologiaSottostantiOptions: [
    { code: "7.1", description: "Gestione Separata" },
    { code: "7.2", description: "Fondi Interni" },
    { code: "7.3", description: "OICR" },
    { code: "7.4", description: "ETF" },
  ],
  prodCommercioOptions: [
    { code: "8.1", description: "Sì" },
    { code: "8.2", description: "No" },
  ],
  tipologiaPremioOptions: [
    { code: "11.1", description: "PIC" },
    { code: "11.2", description: "PAC" },
    { code: "11.3", description: "PIC + PAC" },
    { code: "11.4", description: "PIC o PAC" },
    { code: "11.5", description: "PIC + eventuale PAC" },
    { code: "11.6", description: "PAC + eventuale PIC" },
  ],
  rendMinGarantitoOptions: [
    { code: "30.1", description: "Riconosciuto annualmente" },
    { code: "30.2", description: "Riconosciuto ad evento" },
    { code: "30.3", description: "Non riconosciuto" },
  ],
  presenzaConsolidamentoAnnuoRivalutazioniContrattualiOptions: [
    { code: "32.1", description: "Sì" },
    { code: "32.2", description: "No" },
  ],
  fondoUtiliOptions: [
    { code: "34.1", description: "Presente" },
    { code: "34.2", description: "Non presente" },
  ],
  tipologiaFondiInterniOptions: [
    { code: "37.1", description: "Fondi Interni Azionari" },
    { code: "37.2", description: "Fondi Interni Obbligazionari" },
    { code: "37.3", description: "Fondi Interni Bilanciati" },
    { code: "37.4", description: "Fondi Interni Flessibili" },
    { code: "37.5", description: "Fondi Interni Monetari" },
  ],
  numOICRETFOptions: [
    { code: "38.1", description: "1-50" },
    { code: "38.2", description: "51-100" },
    { code: "38.3", description: "101-250" },
    { code: "38.4", description: "251-500" },
    { code: "38.5", description: "501-1000" },
    { code: "38.6", description: ">1000" },
  ],
  presenzaProtezioneCapitaleOptions: [
    { code: "39.1", description: "Sì" },
    { code: "39.2", description: "No" },
  ],
  opzioniContrattualiTipologiaOptions: [
    { code: "45.1", description: "Cedola" },
    { code: "45.2", description: "Decumulo" },
    { code: "45.3", description: "Rendita" },
    { code: "45.4", description: "Stop Loss" },
    { code: "45.5", description: "Take Profit" },
    { code: "45.6", description: "Progressive Investment" },
    { code: "45.7", description: "Automatic Rebalance" },
    { code: "45.8", description: "Downtrend Opportunity" },
    { code: "45.9", description: "Life Cycle" },
    { code: "45.10", description: "Altre opzioni contrattuali" },
    { code: "45.11", description: "Non presenti" },
  ],
  garanzieAssicurativeTipologiaOptions: [
    { code: "62.1", description: "Maggiorazione caso morte standard" },
    { code: "62.2", description: "Maggiorazione caso morte per infortunio" },
    { code: "62.3", description: "Maggiorazione caso morte per incidente stradale" },
    { code: "62.4", description: "Maggiorazione caso morte per minusvalenza" },
    { code: "62.5", description: "TCM stand alone" },
    { code: "62.6", description: "Long Term Care" },
    { code: "62.7", description: "Dread Disease" },
    { code: "62.8", description: "Invalidità/Inabilità" },
    { code: "62.9", description: "Altre garanzie assicurative" },
    { code: "62.10", description: "Non presenti" },
  ],
  maggiorazioneCasoMorteStandardOptions: [
    { code: "63.1", description: "Ramo I" },
    { code: "63.2", description: "Ramo III" },
    { code: "63.3", description: "Ramo I + Ramo III" },
  ],
  maggiorazioneCasoMortePerInfortunioOptions: [
    { code: "65.1", description: "Facoltativa" },
    { code: "65.2", description: "Obbligatoria" },
  ],
  maggiorazioneCasoMortePerIncidenteStradaleOptions: [
    { code: "67.1", description: "Facoltativa" },
    { code: "67.2", description: "Obbligatoria" },
  ],
  maggiorazioneCasoMortePerMinusvalenzaOptions: [
    { code: "69.1", description: "Facoltativa" },
    { code: "69.2", description: "Obbligatoria" },
  ],
  TCMStandAloneOptions: [
    { code: "71.1", description: "Facoltativa" },
    { code: "71.2", description: "Obbligatoria" },
  ],
  longTermCareOptions: [
    { code: "73.1", description: "Facoltativa" },
    { code: "73.2", description: "Obbligatoria" },
  ],
  dreadDiseaseOptions: [
    { code: "75.1", description: "Facoltativa" },
    { code: "75.2", description: "Obbligatoria" },
  ],
  invaliditaInabilitaOptions: [
    { code: "77.1", description: "Facoltativa" },
    { code: "77.2", description: "Obbligatoria" },
  ],
  tipologiaBonusIngressoOptions: [
    { code: "81.1", description: "Percentuale fissa" },
    { code: "81.2", description: "Fasce cumulo premi versati" },
    { code: "81.3", description: "Fasce scaglioni cumulo premi versati (criterio Irpef)" },
    { code: "81.4", description: "Fasce premi versati annui" },
    { code: "81.5", description: "Fasce patrimonio potenziale" },
    { code: "81.6", description: "Altro" },
    { code: "81.7", description: "Non riconosciuto" },
  ],
  tipologiaBonusFedeltaOptions: [
    { code: "83.1", description: "Percentuale del capitale" },
    { code: "83.2", description: "Percentuale dei premi versati" },
    { code: "83.3", description: "Percentuale del premio ricorrente" },
    { code: "83.4", description: "Altro" },
    { code: "83.5", description: "Non riconosciuto" },
  ],
  tipologiaCaricamentoPICOptions: [
    { code: "86.1", description: "Percentuale fissa" },
    { code: "86.2", description: "Fasce cumulo premi versati" },
    { code: "86.3", description: "Fasce scaglioni cumulo premi versati (criterio Irpef)" },
    { code: "86.4", description: "Fasce premi versati annui" },
    { code: "86.5", description: "Percentuale funzione del tempo" },
    { code: "86.6", description: "Fasce cumulo premi versati funzione del tempo" },
    { code: "86.7", description: "Fasce scaglioni cumulo premi versati (criterio Irpef) funzione del tempo" },
    { code: "86.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "86.9", description: "Fasce patrimonio potenziale" },
    { code: "86.10", description: "Fasce patrimonio potenziale e fasce cumulo premi versati" },
    { code: "86.11", description: "Fasce cumulo premi versati e fasce versamenti futuri previsti" },
    { code: "86.12", description: "Percentuale funzione della durata contrattuale" },
    { code: "86.13", description: "Percentuale funzione della durata piano pagamento premi" },
    { code: "86.14", description: "Fasce importo totale piano pagamento premi" },
    { code: "86.15", description: "Altro" },
    { code: "86.16", description: "Non applicato" },
  ],
  tipologiaCaricamentoPACOptions: [
    { code: "88.1", description: "Percentuale fissa" },
    { code: "88.2", description: "Fasce cumulo premi versati" },
    { code: "88.3", description: "Fasce scaglioni cumulo premi versati (criterio Irpef)" },
    { code: "88.4", description: "Fasce premi versati annui" },
    { code: "88.5", description: "Percentuale funzione del tempo" },
    { code: "88.6", description: "Fasce cumulo premi versati funzione del tempo" },
    { code: "88.7", description: "Fasce scaglioni cumulo premi versati (criterio Irpef) funzione del tempo" },
    { code: "88.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "88.9", description: "Fasce patrimonio potenziale" },
    { code: "88.10", description: "Fasce patrimonio potenziale e fasce cumulo premi versati" },
    { code: "88.11", description: "Fasce cumulo premi versati e fasce versamenti futuri previsti" },
    { code: "88.12", description: "Percentuale funzione della durata contrattuale" },
    { code: "88.13", description: "Percentuale funzione della durata piano pagamento premi" },
    { code: "88.14", description: "Fasce importo totale piano pagamento premi" },
    { code: "88.15", description: "Altro" },
    { code: "88.16", description: "Non applicato" },
  ],
  tipologiaCommissioneGestioneSeparataOptions: [
    { code: "91.1", description: "Percentuale fissa" },
    { code: "91.2", description: "Fasce cumulo capitale" },
    { code: "91.3", description: "Fasce scaglioni cumulo capitale (criterio Irpef)" },
    { code: "91.4", description: "Fasce premi versati annui" },
    { code: "91.5", description: "Percentuale funzione del tempo" },
    { code: "91.6", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "91.7", description: "Fasce scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "91.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "91.9", description: "Percentuale del rendimento gestione separata" },
    { code: "91.10", description: "Percentuale funzione del rendimento gestione separata" },
    { code: "91.11", description: "Altro" },
  ],
  tipologiaCommissioneFondiInterniOptions: [
    { code: "93.1", description: "Percentuale fissa" },
    { code: "93.2", description: "Fasce cumulo capitale" },
    { code: "93.3", description: "Fasce scaglioni cumulo capitale (criterio Irpef)" },
    { code: "93.4", description: "Fasce premi versati annui" },
    { code: "93.5", description: "Percentuale funzione del tempo" },
    { code: "93.6", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "93.7", description: "Fasce scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "93.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "93.9", description: "Altro" },
  ],
  tipologiaSpeseGestionePolizzaOICRETFOptions: [
    { code: "100.1", description: "Percentuale fissa" },
    { code: "100.2", description: "Fasce cumulo capitale" },
    { code: "100.3", description: "Fasce scaglioni cumulo capitale (criterio Irpef)" },
    { code: "100.4", description: "Fasce premi versati annui" },
    { code: "100.5", description: "Percentuale funzione del tempo" },
    { code: "100.6", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "100.7", description: "Fasce scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "100.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "100.9", description: "Altro" },
  ],
  applicazioneCommissioniOverperformanceOptions: [
    { code: "107.1", description: "Sì" },
    { code: "107.2", description: "No" },
  ],
  applicazioneCommissioniUscitaOptions: [
    { code: "110.1", description: "Standard" },
    { code: "110.2", description: "Non standard" },
    { code: "110.3", description: "Non applicate" },
  ],
  yesNoOptions: [
    { code: "true", description: "Sì" },
    { code: "false", description: "No" },
  ],
  facoltativaObbligatoriaOptions: [
    { code: "f", description: "Facoltativa" },
    { code: "o", description: "Obbligatoria" },
  ],
  sostenibilitaOptions: [
    { code: "117.1", description: "Polizza dichiarata non sostenibile" },
    { code: "117.2", description: "Art. 8" },
    { code: "117.3", description: "Art. 9" },
    { code: "117.4", description: "Non indicato" },
    { code: "117.5", description: "Non disponibile" },
  ],
  ramoISFDROptions: [
    { code: "118.1", description: "Art. 6" },
    { code: "118.2", description: "Art. 8" },
    { code: "118.3", description: "Art. 9" },
    { code: "118.4", description: "Non indicato" },
  ],
  ramoITassonomiaUEOptions: [
    { code: "119.1", description: "No Art. 5-6" },
    { code: "119.2", description: "Sì Art. 5-6" },
    { code: "119.3", description: "Non indicato" },
  ],
  ramoIPAIOptions: [
    { code: "121.1", description: "E" },
    { code: "121.2", description: "S" },
    { code: "121.3", description: "G" },
    { code: "121.4", description: "E+S" },
    { code: "121.5", description: "E+G" },
    { code: "121.6", description: "S+G" },
    { code: "121.7", description: "E+S+G" },
    { code: "121.8", description: "Non presenti" },
    { code: "121.9", description: "Non indicato" },
  ],
  ramoIIIPresenzaFondiInterniArt8SFDROptions: [
    { code: "122.1", description: "Sì" },
    { code: "122.2", description: "No" },
  ],
  ramoIIITassonomiaUEFondiInterniArt8Options: [
    { code: "125.1", description: "No Art. 5-6" },
    { code: "125.2", description: "Sì Art. 5-6" },
    { code: "125.3", description: "Non indicato" },
  ],
  ramoIIIPresenzaFondiInterniArt9SFDROptions: [
    { code: "127.1", description: "Sì" },
    { code: "127.2", description: "No" },
  ],
  ramoIIITassonomiaUEFondiInterniArt9Options: [
    { code: "130.1", description: "No Art. 5-6" },
    { code: "130.2", description: "Sì Art. 5-6" },
    { code: "130.3", description: "Non indicato" },
  ],
  ramoIIIPAIFondiInterniOptions: [
    { code: "132.1", description: "E" },
    { code: "132.2", description: "S" },
    { code: "132.3", description: "G" },
    { code: "132.4", description: "E+S" },
    { code: "132.5", description: "E+G" },
    { code: "132.6", description: "S+G" },
    { code: "132.7", description: "E+S+G" },
    { code: "132.8", description: "Non presenti" },
    { code: "132.9", description: "Non indicato" },
  ],
  ramoIIIPresenzaOICRETFArt8SFDROptions: [
    { code: "133.1", description: "Sì" },
    { code: "133.2", description: "No" },
  ],
  ramoIIITassonomiaUEOICRETFArt8Options: [
    { code: "136.1", description: "No Art. 5-6" },
    { code: "136.2", description: "Sì Art. 5-6" },
    { code: "136.3", description: "Non indicato" },
  ],
  ramoIIIPresenzaOICRETFArt9SFDROptions: [
    { code: "137.1", description: "Sì" },
    { code: "137.2", description: "No" },
  ],
  ramoIIITassonomiaUEOICRETFArt9Options: [
    { code: "140.1", description: "No Art. 5-6" },
    { code: "140.2", description: "Sì Art. 5-6" },
    { code: "140.3", description: "Non indicato" },
  ],
  ramoIIIPAIOICRETFOptions: [
    { code: "141.1", description: "E" },
    { code: "141.2", description: "S" },
    { code: "141.3", description: "G" },
    { code: "141.4", description: "E+S" },
    { code: "141.5", description: "E+G" },
    { code: "141.6", description: "S+G" },
    { code: "141.7", description: "E+S+G" },
    { code: "141.8", description: "Non presenti" },
    { code: "141.9", description: "Non indicato" },
  ],
};

const selectChoices = {
  piuVersioni: { code: "", description: "" },
  compagnia: { code: "", description: "" },
  mercato: [], // multiselect
  canale: [], // multiselect
  tipologiaProdotto: { code: "", description: "" },
  tipologiaSottostanti: [], // multiselect
  prodCommercio: { code: "", description: "" },
  tipologiaPremio: { code: "", description: "" },
  rendMinGarantito: { code: "", description: "" },
  presenzaConsolidamentoAnnuoRivalutazioniContrattuali: { code: "", description: "" },
  fondoUtili: { code: "", description: "" },
  tipologiaFondiInterni: [],
  numOICRETF: { code: "", description: "" },
  presenzaProtezioneCapitale: { code: "", description: "" },
  opzioniContrattualiTipologia: [],
  garanzieAssicurativeTipologia: [],
  maggiorazioneCasoMorteStandard: { code: "", description: "" },
  maggiorazioneCasoMortePerInfortunio: { code: "", description: "" },
  maggiorazioneCasoMortePerIncidenteStradale: { code: "", description: "" },
  maggiorazioneCasoMortePerMinusvalenza: { code: "", description: "" },
  TCMStandAlone: { code: "", description: "" },
  longTermCare: { code: "", description: "" },
  dreadDisease: { code: "", description: "" },
  invaliditaInabilita: { code: "", description: "" },
  tipologiaBonusIngresso: { code: "", description: "" },
  tipologiaBonusFedelta: { code: "", description: "" },
  tipologiaCaricamentoPIC: { code: "", description: "" },
  tipologiaCaricamentoPAC: { code: "", description: "" },
  tipologiaCommissioneGestioneSeparata: { code: "", description: "" },
  tipologiaCommissioneFondiInterni: { code: "", description: "" },
  tipologiaSpeseGestionePolizzaOICRETF: { code: "", description: "" },
  applicazioneCommissioniOverperformance: { code: "", description: "" },
  applicazioneCommissioniUscita: { code: "", description: "" },
  sostenibilita: { code: "", description: "" },
  ramoISFDR: { code: "", description: "" },
  ramoITassonomiaUE: { code: "", description: "" },
  ramoIPAI: { code: "", description: "" },
  ramoIIIPresenzaFondiInterniArt8SFDR: { code: "", description: "" },
  ramoIIITassonomiaUEFondiInterniArt8: { code: "", description: "" },
  ramoIIIPresenzaFondiInterniArt9SFDR: { code: "", description: "" },
  ramoIIITassonomiaUEFondiInterniArt9: { code: "", description: "" },
  ramoIIIPAIFondiInterni: { code: "", description: "" },
  ramoIIIPresenzaOICRETFArt8SFDR: { code: "", description: "" },
  ramoIIITassonomiaUEOICRETFArt8: { code: "", description: "" },
  ramoIIIPresenzaOICRETFArt9SFDR: { code: "", description: "" },
  ramoIIITassonomiaUEOICRETFArt9: { code: "", description: "" },
  ramoIIIPAIOICRETF: { code: "", description: "" },
}

export { selectChoices };
export default data;
